module.exports = __webpack_public_path__ + "static/media/Web Backend Meet-Up.bc51fb6f.png";